import { render, staticRenderFns } from "./screenIndexPage.vue?vue&type=template&id=6f4de9ae&scoped=true"
import script from "./screenIndexPage.vue?vue&type=script&lang=js"
export * from "./screenIndexPage.vue?vue&type=script&lang=js"
import style0 from "./screenIndexPage.vue?vue&type=style&index=0&id=6f4de9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4de9ae",
  null
  
)

export default component.exports